import { render, staticRenderFns } from "./CategoryEditor.vue?vue&type=template&id=0535ea64&"
import script from "./CategoryEditor.vue?vue&type=script&lang=ts&"
export * from "./CategoryEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryEditor.vue?vue&type=style&index=0&id=0535ea64&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports